import { signal } from "@angular/core";
import { type PluginStoreModel } from "@bitwarden/web-vault/app/models/store/plugin.store.model";
import { type StoreModelNames } from "@bitwarden/web-vault/app/services/dali/type/dali.type";
import { StoreModelCollection } from "@bitwarden/web-vault/app/services/store/model.collection.abstraction";
import {
  type PluginView,
  fromStoreModel,
  fromView,
} from "@bitwarden/web-vault/app/models/view/plugin/plugin.view";

import { PluginConfigService } from "@bitwarden/web-vault/app/services/store/data-plugin/plugin-config.service";

export class PluginStoreCollection extends StoreModelCollection {
  protected type: StoreModelNames = "PluginStoreModel";
  protected models: Map<string, PluginStoreModel> = new Map<string, PluginStoreModel>();
  private _collection = signal<PluginView[]>(null);
  readonly collection = this._collection.asReadonly();

  triggerChanges(): void {
    const views: PluginView[] = [];
    this.models.forEach((model) => {
      views.push(this.deepFreeze(fromStoreModel(model)));
    });
    this._collection.set(views);
  }

  async saveConfigs(configStr: string): Promise<boolean> {
    const configs = PluginConfigService.fromString(configStr);

    if (!configs) {
      return false;
    }

    const views = configs.reduce<PluginView[]>((acc, config) => {
      const { name, keyId, url } = config;
      const model = this.findByName(name);
      const view = model ? fromStoreModel(model) : fromView({ name, keyId, url });

      if (model && view.url === url && view.keyId === keyId && view.name === name) {
        return acc;
      } else {
        view.url = url;
        view.keyId = keyId;
        view.name = name;
      }

      acc.push(view);
      return acc;
    }, []);

    if (views.length === 0) {
      return true;
    }

    return await this.saveToVault(views, true);
  }

  clear(): void {
    this.models.clear();
    this._collection.set(null);
  }

  private findByName(name: string): PluginStoreModel | null {
    for (const model of this.models.values()) {
      if (model.nm === name) {
        return model;
      }
    }
    return null;
  }
}
